module.exports = __webpack_public_path__ + "static/media/whoweare_section2_onelayer@2x.e07b480a.png";